import axios from 'axios';

interface User {
  id: string;
  email: string;
  name: string;
  roles: string[];
}

interface AuthStatus {
  authenticated: boolean;
  user?: User;
  reason?: string;
  message?: string;
}

class AuthService {
  /**
   * Check authentication status
   */
  async checkAuthStatus(): Promise<AuthStatus> {
    try {
      const response = await axios.get('/auth/status', {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.error('Failed to check auth status:', error);
      return { authenticated: false };
    }
  }

  /**
   * Logout user
   */
  async logout(): Promise<void> {
    try {
      await axios.post('/auth/logout', {}, {
        withCredentials: true
      });
    } catch (error) {
      console.error('Logout failed:', error);
      throw error;
    }
  }

  /**
   * Check if user has ProviderValidator access
   */
  hasProviderValidatorAccess(user: User | null): boolean {
    if (!user || !user.roles) {
      return false;
    }
    return user.roles.some(role => role.includes('ProviderValidator'));
  }
}

export const authService = new AuthService();
export default authService;
